import { render, staticRenderFns } from "./official_extension.vue?vue&type=template&id=31261d5e&scoped=true&"
import script from "./official_extension.vue?vue&type=script&lang=js&"
export * from "./official_extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31261d5e",
  null
  
)

export default component.exports